import { render, staticRenderFns } from "./ModalJson.vue?vue&type=template&id=3b2538c9&"
import script from "./ModalJson.vue?vue&type=script&lang=js&"
export * from "./ModalJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports